var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{attrs:{"src":"https://usermodel-assets.s3.ap-northeast-1.amazonaws.com/musio-english-assets/ESAT-J/App+Icon-premium+1.png"}})
}
var staticRenderFns = []

export { render, staticRenderFns }